var map = {
	"./add-action.svg": "5dfd",
	"./calendar-dark.svg": "776f",
	"./calendar-darker.svg": "110f",
	"./calendar.svg": "b8bd",
	"./cancelled.svg": "0e73",
	"./close.svg": "8b1b",
	"./customer-active-subnav.svg": "e4d6",
	"./customer-subnav.svg": "8bf5",
	"./customer.svg": "64ef",
	"./dash-customer-img.svg": "a383",
	"./dash-graph-img.svg": "51fb",
	"./dash-orders-img.svg": "bd19",
	"./dash-users1-img.svg": "67a5",
	"./dash-users2-img.svg": "6fb9",
	"./dash-warehouse1-img.svg": "aa1c",
	"./dash-warehouse2-img.svg": "1775",
	"./delete.svg": "0d45",
	"./delivery-active.svg": "68ee",
	"./delivery.svg": "4a78",
	"./destination.svg": "16c0",
	"./diamond-icon.svg": "4df9",
	"./down-arrow.svg": "fcc4",
	"./driver-active.svg": "d665",
	"./driver.svg": "345c",
	"./edit.svg": "daf0",
	"./export.svg": "1578",
	"./feedback.svg": "eaaf",
	"./filter.svg": "2376",
	"./frame.svg": "4fcc",
	"./increment.svg": "4c7c",
	"./login-img.svg": "eff4",
	"./logout.svg": "69e3",
	"./map-marker.svg": "1a5b",
	"./more-delete.svg": "35bc",
	"./more-options.svg": "8aa3",
	"./mylocation.svg": "a8b6",
	"./no-access.svg": "a72c",
	"./no-content.svg": "a0f4",
	"./no-order.svg": "4914",
	"./order-active-subnav.svg": "9a73",
	"./order-delivered.svg": "3f51",
	"./order-dispatch.svg": "8568",
	"./order-overview.svg": "01de",
	"./order-subnav.svg": "6693",
	"./orders-active.svg": "5eec",
	"./orders.svg": "3ca5",
	"./pencil-iisc.svg": "2594",
	"./pencil-rfs.svg": "fe86",
	"./pencil.svg": "e51f",
	"./product-active-subnav.svg": "2d81",
	"./product-subnav.svg": "63ac",
	"./product.svg": "2542",
	"./reset-active.svg": "fde1",
	"./reset.svg": "c680",
	"./right-arrow.svg": "c686",
	"./search.svg": "d103",
	"./settings.svg": "9174",
	"./star-active.svg": "3ff9",
	"./star-inactive.svg": "fb76",
	"./table-expansion-closed.svg": "a57f",
	"./table-expansion-open.svg": "bc46",
	"./total-merchant.svg": "d880",
	"./user-active.svg": "ba69",
	"./user-icon.svg": "149a",
	"./user.svg": "6aed",
	"./warehouse-active-subnav.svg": "1651",
	"./warehouse-active.svg": "c75c",
	"./warehouse-dummy.svg": "25c3",
	"./warehouse-subnav.svg": "ecac",
	"./warehouse.svg": "e53c",
	"./white-close.svg": "a2f4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";